import gql from 'graphql-tag'

export const ADD_ARTICLE = gql`
mutation(
    $title:String!
  $file:FileInput!
    $detail:String!
    $BlogTypeId:[ID]!
    $openingDate: Date
    $closingDate: Date
  ){
    addBlog(info:{
      title:$title
      file:$file
      detail:$detail
      BlogTypeId:$BlogTypeId
      openingDate:$openingDate
      closingDate:$closingDate
    })
    {
      _id
      title
      FileId{
        _id
        src
        link
        mimeType
        size
      }
      detail
      BlogTypeId{
        _id
        name
      }
    }
  }
`
export const GET_ARTICLE = gql`
query(
  $page:Int!
  $perPage:Int!
  $search:ID
){
  getBlog(page:$page perPage:$perPage search:$search){
    blog{
      _id
      title
      FileId{
        src
      }
      detail
      BlogTypeId{
        _id
        name
      }
      createdAt
    }
    totals
  }
}
`

export const SEARCH_ARTICLE = gql`
query(
    $id:ID!
    ){
      findBlog(id:$id){
        _id
          title
          FileId{
            _id
            src
            link
            mimeType
            size
          }
          detail
          BlogTypeId{
            _id
            name
          }
          openingDate
          closingDate
        createdAt
      }
    }    
`
export const UPDATE_ARTICLE = gql`
mutation(
    $blogId:ID!
    $title:String!
  $file:Fileupdate
    $detail:String!
    $BlogTypeId:[ID]!
    $openingDate: Date
    $closingDate: Date
  ){
    updateBlog(info:{
      blogId:$blogId
      title:$title
      file:$file
      detail:$detail
      BlogTypeId:$BlogTypeId
      openingDate:$openingDate
      closingDate:$closingDate
    })
    {
      _id
      title
      FileId{
        _id
        src
        link
        mimeType
        size
      }
      detail
      BlogTypeId{
        _id
        name
      }
    }
  }
`
export const DELETE_ARTICLE = gql`
mutation(
  $blogId:ID!
){
  deleteBlog (
    blogId:$blogId
  )
}
`